export default "__VITE_ASSET__DyXqSFDd__"